export const ANNOUNCEMENTS_FETCH_DATA_REQUEST = 'ANNOUNCEMENTS/FETCH_DATA_REQUEST';
export const ANNOUNCEMENTS_FETCH_DATA_ERROR = 'ANNOUNCEMENTS/FETCH_DATA_ERROR';
export const ANNOUNCEMENTS_FETCH_DATA_SUCCESS = 'ANNOUNCEMENTS/FETCH_DATA_SUCCESS';

export const ANNOUNCEMENT_MARK_AS_SEEN_REQUEST = 'ANNOUNCEMENT_MARK_AS_SEEN/REQUEST';
export const ANNOUNCEMENT_MARK_AS_SEEN_ERROR = 'ANNOUNCEMENT_MARK_AS_SEEN/ERROR';
export const ANNOUNCEMENT_MARK_AS_SEEN_SUCCESS = 'ANNOUNCEMENT_MARK_AS_SEEN/SUCCESS';
